import type { TooltipProps } from "@chakra-ui/react"
import { Tooltip } from "@chakra-ui/react"
import type { FC } from "react"
import React from "react"

const NumberTooltip: FC<TooltipProps> = ({ children, ...tooltipProps }) => (
  <Tooltip hasArrow placement="top" {...tooltipProps}>
    {children}
  </Tooltip>
)

export default NumberTooltip
